<script setup lang="ts">
const props = withDefaults(defineProps<{
    href?: string,
    icon?: string,
    iconScale?: number,
    active?: boolean,
    tooltip?: string,
    isDjangoRoute?: boolean,
}>(), {
    iconScale: 2,
    active: false,
    isDjangoRoute: false,
});

</script>

<template>
    <div class="nav-item-container" :class="{ active }">
        <component v-if="href" :is="isDjangoRoute ? 'a' : 'router-link'" :to="!isDjangoRoute ? href : undefined"
            :href="isDjangoRoute ? href : undefined">
            <v-icon v-if="icon" :name="icon" :scale="iconScale" />
            <slot />
        </component>
        <v-icon v-else-if="icon" :name="icon" :scale="iconScale" />
        <slot v-else />
        <div v-if="tooltip" class="tooltip">
            {{ tooltip }}
        </div>
    </div>
</template>

<style scoped>
svg {
    color: white;
}

svg:hover {
    color: var(--color-orange);
    transform: scale(1.1);
}

div.active svg {
    color: var(--color-orange);
}

.nav-item-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    width: fit-content;
}

.nav-item-container:hover .tooltip {
    display: block;
    top: 3.5rem;
    left: 0;
}

.tooltip {
    position: absolute;
    background-color: var(--color-grey);
    color: white;
    padding: 0.5rem;
    border-radius: 0.5rem;
    font-size: 0.8rem;
    z-index: 10;
    display: none;
    white-space: nowrap;
}
</style>